import { debounce } from 'lodash';
import { IWixStatic } from '@wix/native-components-infra/dist/src/types/wix-sdk';
import { TPADeviceType, TPAEditMode } from '../constants';

const MIN_WIDTH_MAP = {
  [TPADeviceType.DESKTOP]: 980,
  [TPADeviceType.MOBILE]: 320,
};

function resizeConstraint(Wix: IWixStatic, minWidth: number) {
  return event => {
    const viewMode = Wix.Utils.getViewMode();
    const newWidth = event.target.innerWidth;

    if (viewMode === TPAEditMode.EDITOR && newWidth < minWidth) {
      Wix.resizeComponent({
        width: minWidth,
        height: event.target.innerHeight,
      });
    }
  };
}

export function setWidthRestrictions(Wix: IWixStatic) {
  const deviceType = Wix.Utils.getDeviceType();
  const minWidth =
    MIN_WIDTH_MAP[deviceType] || MIN_WIDTH_MAP[TPADeviceType.DESKTOP];

  window.addEventListener(
    'resize',
    debounce(resizeConstraint(Wix, minWidth), 600),
  );
}
